// extracted by mini-css-extract-plugin
export default {"content":"SessionTimeoutMonitor_content__mRYwZ"};